import 'mosha-vue-toastify/dist/style.css'
import { createToast } from 'mosha-vue-toastify'
function showToast(type, text) {
  createToast({ title: '', description: text }, { type: type, showIcon: true, position: 'top-center', timeout: 5000, transition: 'slide' })
}

export { showToast }
